import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { NzUploadFile } from 'ng-zorro-antd/upload';

const baseRef = 'arquivos';
const route = {
  downloadArquivo: (id: number) => `${baseRef}/${id}`,
  salvarArquivo: `${baseRef}`,
  deletarArquivo: (id: number) => `${baseRef}/${id}`
};

export function toRawFile(file: File | NzUploadFile): File {
  if (file instanceof File) {
    return file;
  }
  return (file.originFileObj as File) || (file as unknown as File);
}

@Injectable({
  providedIn: 'root'
})
export class ArquivoService {

  constructor(private apiService: ApiService) {}

  downloadArquivo(id: number) {
    return this.apiService.downloadGet(`${route.downloadArquivo(id)}`);
  }

  salvarArquivo(file: File | NzUploadFile): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', toRawFile(file));

    return this.apiService.post<any>(route.salvarArquivo, formData);
  }

  deletarArquivo(id: number): Observable<any> {
    return this.apiService.delete<void>(`${route.deletarArquivo(id)}`);
  }

}
